export default __webpack_public_path__ + "static/media/app.ce0909bc.jpg";